module.exports = "https://cdn.hellotech.com/client-assets/advanced_audio_systems_desktop_780a6e98ab9a4cee3e5d200ca64f5ece.png";